export class ExpenseEntryGridConfigModel {
    id = 0;
    User: number = null;
    Configuration = '';
}